<template>
  <div>
    <div class="ml-l pl-l mb-l pb-l">
      <el-button @click="$router.back()" size="small">返回</el-button>
    </div>
    <div class="container">
      <h3>优惠券模版详情</h3>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="名称">
          <div>{{ coupontemplate.name }}</div>
        </el-form-item>
        <el-form-item label="面值类型">
          <div>{{ coupontemplate.amountkind == 0 ? '随机金额' : '固定金额' }}</div>
        </el-form-item>
        <el-form-item label="面值" v-show="coupontemplate.amountkind == 1">
          <div>{{ $amount1(coupontemplate.amount) }}元</div>
        </el-form-item>
        <el-form-item label="面值" v-show="coupontemplate.amountkind == 0">
          <div>{{ $amount1(coupontemplate.amountbegin) }}元 ~ {{ $amount1(coupontemplate.amountend) }}元</div>
        </el-form-item>
        <el-form-item label="使用规则">
          <div>满{{ $amount1(coupontemplate.reach) }}可用</div>
        </el-form-item>
        <el-form-item label="有效时间">
          <div v-if="coupontemplate.timekind === 0">不限制</div>
          <div v-if="coupontemplate.timekind === 2">发放或领取后{{ coupontemplate.duration / 60 / 60 / 24 }}天</div>
        </el-form-item>
        <el-form-item label="适用商品">
          <div>
            <div v-if="coupontemplate.producttype === 0">可用于全部商品</div>
            <div v-if="coupontemplate.producttype === 1">可用于部分商品</div>
            <div v-if="coupontemplate.producttype === 2">不可用于部分商品</div>
            <div v-if="coupontemplate.producttype !== 0">
              <span :key="product.id" class="coupon-category" v-for="product in coupontemplate.productlist">{{ product.name }}</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="删除时间" v-if="coupontemplate.deletedat > 0">
          <div>{{ new Date(coupontemplate.deletedat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}</div>
        </el-form-item>

        <el-form-item label="创建时间">
          <div>{{ new Date(coupontemplate.createdat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';
export default {
  data() {
    return {
      coupontemplate: {}
    };
  },
  async created() {
    this.token = getToken();
    const res = await rpc(
      'StoreCouponTemplateService.GetCouponTemplate',
      M('IDWithTokenRequest', {
        token: M('Token', { token: this.token }),
        id: this.$route.query.id
      })
    );
    const reslist = await Promise.all([
      res.categoryidsList.length
        ? rpc(
            'StoreCategoryService.GetCategoryList',
            M('CategoryListQueryRequest', {
              token: M('Token', { token: this.token }),
              idlistList: res.categoryidsList,
              level: 1,
              count: res.categoryidsList.length,
              sortby: 1
            })
          )
        : null,
      res.productidsList.length
        ? rpc(
            'StoreProductService.GetProductList',
            M('ProductListQueryRequest', {
              token: M('Token', { token: this.token }),
              idlistList: res.productidsList,
              sortby: 1,
              sort: 1,
              count: res.productidsList.length
            })
          )
        : null
    ]);
    res.categorylist = res.categoryidsList.map(item => reslist[0].categorylistList.find(v => v.id === item));
    res.productlist = res.productidsList.map(item => reslist[1].productlistList.find(v => v.id === item));
    this.coupontemplate = res;
  }
};
</script>

<style>
.coupon-category {
  padding: 4px 8px;
  font-size: 12px;
  background-color: #e9e9e9;
  margin-right: 5px;
}
</style>
